import { defineStore } from 'pinia'

import type { PadStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const usePadStore = defineStore('pad', {
  state: (): PadStore => ({
    loading: false,
    _hydratedMath: false,
    _hydratedEla: false,
    plansMath: null,
    plansEla: null,
    paceMath: null,
    paceEla: null,
    periodIndex: null,
    countdownExpired: true,
    modalFaq: false,
  }),
  actions,
  getters,
})
